import { BrowserRouter, Route, Routes } from "react-router-dom";

import {
  AuthLayout,
  ClinicLayout,
  EmptyLayout,
  QioskLayout,
  PatientLayout,
  ProviderLayout,
} from "layouts";

import {
  Auth,
  Clinic,
  Common,
  Qiosk,
  Patient,
  Provider,
  Redirect,
} from "pages";

import { Error } from "components";
import { useApp } from "context";
import { Protected } from "middlewares";
import { Helpers, Routes as Urls, Store } from "utils";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const { user } = useApp();
  const isAuthenticated = Helpers.hasValue(user.wq);
  const isClinic = Store.sessionStorage.isClinic();
  const isProvider = Store.sessionStorage.isProvider();
  const isPatient = Store.sessionStorage.isPatient();
  const isActive = user.active === true;
  const isCompleted = user.completed === true;
  const consentPending =
    user.appointments &&
    user.appointments.filter((x) => !x.consented).length > 0;
  const showConsent = user.agreed === false || (consentPending ?? false);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AuthLayout />}>
          <Route
            index
            element={
              <Protected
                condition={isAuthenticated}
                redirectTo={Urls.patient.home}
              >
                <Auth.SignIn />
              </Protected>
            }
          />
          <Route
            path="hub/:id"
            element={
              <Protected
                condition={isAuthenticated}
                redirectTo={Urls.patient.home}
              >
                <Auth.SignIn />
              </Protected>
            }
          />
          <Route
            path="sign-up"
            element={
              <Protected
                condition={isAuthenticated}
                redirectTo={Urls.patient.home}
              >
                <Auth.SignUp />
              </Protected>
            }
          />
          <Route
            path="forgot-password"
            element={
              <Protected
                condition={isAuthenticated}
                redirectTo={Urls.patient.home}
              >
                <Auth.ForgotPassword />
              </Protected>
            }
          />
          <Route
            path="reset-password/:id"
            element={
              <Protected
                condition={isAuthenticated}
                redirectTo={Urls.patient.home}
              >
                <Auth.ResetPassword />
              </Protected>
            }
          />
          <Route
            path="account-verification/:method"
            element={
              <Protected condition={isActive} redirectTo={Urls.patient.home}>
                <Auth.AccountVerification />
              </Protected>
            }
          />
          <Route
            path="consent"
            element={
              <Protected
                condition={!isAuthenticated}
                redirectTo={Urls.auth.signin}
              >
                <Protected
                  condition={!showConsent}
                  redirectTo={Urls.patient.home}
                >
                  <Auth.Consent />
                </Protected>
              </Protected>
            }
          />
        </Route>

        <Route
          path="/qiosk"
          element={
            <Protected
              condition={!isAuthenticated}
              redirectTo={Urls.auth.signin}
            >
              <Protected condition={!isClinic} redirectTo={Urls.patient.home}>
                <QioskLayout />
              </Protected>
            </Protected>
          }
        >
          <Route index element={<Qiosk.CheckIn />} />
        </Route>

        <Route
          path="/patient"
          element={
            <Protected
              condition={!isAuthenticated}
              redirectTo={Urls.auth.signin}
            >
              <Protected condition={!isPatient} redirectTo={Urls.clinic.home}>
                <Protected
                  condition={showConsent}
                  redirectTo={Urls.auth.consent}
                >
                  <PatientLayout />
                </Protected>
              </Protected>
            </Protected>
          }
        >
          <Route index element={<Patient.Home />} />
          <Route path="chat/:id" element={<Common.Chat />} />
          <Route path="journey" element={<Patient.Journey />} />
        </Route>

        <Route
          path="/clinic"
          element={
            <Protected
              condition={!isAuthenticated}
              redirectTo={Urls.auth.signin}
            >
              <Protected condition={!isClinic} redirectTo={Urls.provider.home}>
                <ClinicLayout />
              </Protected>
            </Protected>
          }
        >
          <Route index element={<Clinic.Home />} />
          <Route path="chat/:id/:userType" element={<Common.Chat />} />
        </Route>

        <Route
          path="/provider"
          element={
            <Protected
              condition={!isAuthenticated}
              redirectTo={Urls.auth.signin}
            >
              <Protected condition={!isProvider} redirectTo={Urls.patient.home}>
                <ProviderLayout />
              </Protected>
            </Protected>
          }
        >
          <Route index element={<Provider.Home />} />
        </Route>

        <Route path="/redirect" element={<EmptyLayout />}>
          <Route path="google" element={<Redirect.Google />} />
        </Route>

        <Route path="*" element={<EmptyLayout />}>
          <Route index element={<Error.Error404 />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
